import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static targets = ["content"];

  declare readonly contentTarget: HTMLElement;
  declare readonly hasContentTarget: boolean;

  declare boundOnTabsChange: (event: CustomEvent) => void;
  private intersectionObserver: IntersectionObserver | null = null;

  center(): void {
    this.element.scrollLeft =
      (this.element.scrollWidth - this.element.clientWidth) / 2;
  }

  contentTargetConnected(): void {
    this.center();

    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.center();

          // Disconnect the observer after handling once to keep the user position.
          this.intersectionObserver.disconnect();
        }
      });
    });
    this.intersectionObserver.observe(this.element);
  }
}
